import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { validationErrorsToString } from '../../../utils';
import { useUpdateTotalNotification } from '../../../utils/useUpdateTotalNotification';

// PACKAGES
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import LoadingSpinner from '../../../components/LoadingSpinner';

// TYPES
import { ComplaintReopenCommand } from '../../../api/models';

interface ReOpenModalTypes {
	complaintId?: string;
}

const ReOpenModal: React.FC<ReOpenModalTypes> = ({ complaintId }) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	// Set up Formik
	const validationSchema = Yup.object({
		commentInput: Yup.string().required('Required')
	});

	const initialValues = {
		commentInput: ''
	};

	const reOpenComplaint = async (values: any) => {
		setIsLoading(true);

		const data: ComplaintReopenCommand = {
			id: complaintId,
			comments: values.commentInput
		};

		const response = await apibridge.reOpenComplaint(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			history.push('/complaints');

			useUpdateTotalNotification();
		}
	};

	return (
		<>
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<Formik
								initialValues={initialValues}
								validationSchema={validationSchema}
								onSubmit={reOpenComplaint}
								enableReinitialize
							>
								{(formik) => {
									return (
										<Form translate="yes" className="general-form mtop-0">
											<p className="mbtom-30">Please provide details around why this complaint is being re-opened.</p>

											<div className="form-group">
												<label htmlFor="commentInput" className="label">
													Comment
												</label>

												<div className="form-field">
													<Field
														as="textarea"
														name="commentInput"
														id="commentInput"
														type="text"
														className="form-input"
													/>
													<ErrorMessage name="commentInput" component="div" className="error-message" />
												</div>
											</div>

											<div className="form-button-group">
												<Button type="submit" className="btn-primary w-100">
													Save
												</Button>
											</div>
										</Form>
									);
								}}
							</Formik>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</>
	);
};

export default ReOpenModal;
